import { ReviewCreateErrorResponseType } from '../types/ReviewCreateErrorResponseType';
import { message } from 'antd';
import { ProductRelatedTagsDto, TagExcelResponseBodyTagsDto, TagsFindResponseBodyTagsDto } from '../types/TagListTypes';
import { formatDatePeriod } from '../../../../../lib/moment';
import { ProductResponseDto } from '../../../../../types/api/products';
import { ProductInfoType } from '../../../../../types/product';
import { SearchResult } from '../../../../../components/common/SearchBar/SearchBar';

export const showErrorMessages = (errors: ReviewCreateErrorResponseType[]): void => {
  for (const error of errors) {
    message.error(error?.message);
  }
};

export const setUploadFile = (requestData: { attachment: File }): FormData => {
  const formData = new FormData();

  if (requestData.attachment) {
    formData.append('attachment', requestData.attachment);
  }
  formData.append('data', JSON.stringify(requestData));
  return formData;
};
const getV1ApiTagStatus = (status: number): string | null => {
  switch (status) {
    case 0:
      return 'confirmReady';
    case 1:
      return 'inactive';
    case 2:
      return 'active';
    case 3:
      return 'delete';
    default:
      return null;
  }
};

export const convertTagsDtoToFindResponseDto = (
  data: TagExcelResponseBodyTagsDto[] | ProductRelatedTagsDto[],
): TagsFindResponseBodyTagsDto[] => {
  return data.map((item, index) => {
    return {
      id: item.id,
      name: item.name,
      status: getV1ApiTagStatus(item.status) || '',
      createDate: item.createdDate,
      updatedDate: '',
      tagGroups: item.tagGroupList?.map((tagGroup, index) => ({
        id: index,
        name: tagGroup,
        createDate: '',
        updatedDate: '',
        type: '',
      })),
      tagAttachments: [
        {
          id: index,
          width: 60,
          height: 60,
          url: item.url,
          createDate: '',
          updatedDate: '',
        },
      ],
    };
  });
};

export const convertProductDataForLegacyComponent = (data: ProductResponseDto): ProductInfoType => {
  return {
    productId: data?.product.id,
    categoryId: data?.product.productCategories[0]?.id,
    mainCategory: data?.product.productCategories[0]?.name ?? '-',
    subCategory:
      data?.product.productCategories
        .filter((category, index) => index > 0)
        .map((category) => category.name)
        .join(' ,') || '-',
    productName: data?.product.name,
    storeId: data?.product.store.id,
    storeName: data?.product.store.storeName,
    storeTier: data?.product.store.storeTier?.tier,
    originPrice: data?.product.originPrice,
    discountPrice: data?.product.discountAmount,
    salesPrice: data?.product.salesPrice,
    sellerCellPhone: data?.product.store.seller.phone,
    storeCellPhone: data?.product.store.phone,
    discountPeriod: formatDatePeriod(data?.product.discountStartDate, data?.product.discountEndDate),
    createDate: data?.product.createDate,
    images: data?.product.productAttachments.filter((image) => image.type === 'mainImg').map((image) => image.url),
  };
};

export const formatUserSearchResult = (result: SearchResult): string => {
  if (!result.name) return `(${result.id}, ${result.cellPhone})`;

  return `${result.name} (${result.id}, ${result.cellPhone})`;
};
